import { Component } from '@angular/core';
import { PAGINA_HOME } from '../../tools/URL'

@Component({
  selector: 'sucesso-cadastro-usuario',
  templateUrl: './sucesso-cadastro-usuario.component.html',
  styleUrls: ['./sucesso-cadastro-usuario.component.css']
})
export class SucessoCadastroUsuarioComponent {
  home = PAGINA_HOME;
}
